import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "./fonts/fontawesome/css/all.css";
import './style.css';
import 'leaflet/dist/leaflet.css'


const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(   
  <HashRouter>
    <App />
  </HashRouter> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
